<template>
    <pp-modal v-model="showModal" :closable="clos" :mask-closable="false" width="488">
        <p slot="header" class="modalHead">
            <span>{{modalheader}}</span>
        </p>
        <div class="modalContent">
            <p>{{modalcontent}} {{currency}} {{$filters.money(amount)}}</p>
            <p>
                <pp-row>
                <pp-col :span="12">
                <pp-form class="formstyle" ref="formCustom" :model="formCustom" :rules="rules">
                    <pp-form-item prop="confirmAmount" class="control-input">
                        <pp-input v-model.trim="formCustom.confirmAmount" :value="formCustom.confirmAmount" type="text" :placeholder="currency" class="inputstyle"></pp-input>
                    </pp-form-item>
                </pp-form>
                </pp-col>
                <pp-col :span="12">
                         <div class="all" @click="getAllAmount">{{$t('webList.webDetail.allFunds')}}</div>
                    </pp-col>
                
                </pp-row>
            </p>
        </div>
         <div slot="footer">
            <pp-button type="primary" size="spec" :loading="loading2" @click="commit()">{{$t('webList.webDetail.confirm')}}</pp-button>
            <!-- <pp-button type="primary" size="small" @click="rightFun">{{rightbtn}}</pp-button> -->
        </div>
    </pp-modal>
</template>

<script>
    import {
        Component,
        Vue,
        Prop,
        Watch
    } from 'vue-property-decorator'
    import {
        createNamespacedHelpers
        } from 'vuex'
        import {
            Getter,
            Action,
            namespace
        } from 'vuex-class'
        const {
            mapGetters: webMapGetters,
            mapActions: webMapActions
        } = createNamespacedHelpers('website')
    export default {
        name: 'cancleModal',
        props: {
            modalcontent: "",
            modalheader: "",
            currency:"",
            params:{},
            amount:"",
        },
        computed:{
            ...webMapGetters(['confirmTradeRes']),
        },
        mounted() {},
        data() {
            return {
                loading2:false,
                showModal: false,
                clos:true,
                rules: {
                confirmAmount: [{
                    required: true,
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
						this.formCustom.confirmAmount = this.$filters.pureMoney(this.formCustom.confirmAmount)
						//Number(this.formCustom.confirmAmount).toFixed(2); 
                    }
                }]
                },  
                formCustom: {
                confirmAmount: '',
                },
                
            }
        },
        methods: {
            ...webMapActions([
                'confirmTrade', // 获取交易详情
            ]),
            getAllAmount(){
                this.formCustom.confirmAmount = this.$filters.pureMoney(this.amount)//Number(this.amount).toFixed(2);
            },
            show() {
                this.showModal = true
                this.formCustom.confirmAmount = '';
            },
            cancle() {
                this.showModal = false
            },
            commit(){
                let value = Number(this.formCustom.confirmAmount)
                let amount = Number(this.amount)
                if(value>amount){
                            this.$message.error(this.$t('webList.withdrawModal.formRules'))
					return false
				}else{
					const amountReg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
					var reg = amountReg.test(value)
					if (reg) {
						this.confirmfun()
					} else {
						this.$message.error(this.$t('webList.withdrawModal.formRules2'))
						return false
					}
				}
            },
            // 获取初始化交易记录数据
            async confirmfun(){
                this.clos = false;
                let params ={
                    currency :this.currency,
                    transactionId : this.params.transactionId,
                    accId : this.params.accId,
                    clientId : this.params.clientId,
                    flowId : this.params.flowId,
                    type:this.params.type,
                    preAuthorizeAmount:this.formCustom.confirmAmount
                }
                this.loading2 = true;
                await this.confirmTrade(params)
                
                setTimeout(() => {
                    this.clos = true;
                    this.loading2 = false;
                    if(this.confirmTradeRes=="提交成功" || this.confirmTradeRes=="SUCCESS"){
                        this.$message.success(this.$t('webList.withdrawModal.success'))
                        this.$emit('finish');
                        this.formCustom.confirmAmount = '';
                        this.showModal = false
                    }
                    
                }, 3000);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .modalHead {
        color: #000;
        font-size: 20px;
        text-align: left
    }
    
    .modalContent {
        text-align: left;
        font-size: 14px;
    }

    .control-input{
        margin: 20px 0;
        width: 200px;
        span{
            display: block;
            float: left;
        }
    }
    .all{
        width: 200px;
        height: 76px;
        line-height: 76px;
        cursor: pointer;
        color: #1fa0e8;
    }
</style>
